import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GioDatePipe } from './gio-date.pipe';
import { GioNoSanitizePipe } from './gio-no-sanitize.pipe';
import { GioEntityNamePipe } from './gio-entity-name.pipe';
import { GioNameFormatterPipe } from './gio-name-formatter.pipe';
import { GioStringFormatPipe } from './gio-string-format.pipe';


@NgModule({
  declarations: [GioDatePipe, GioNoSanitizePipe, GioEntityNamePipe, GioNameFormatterPipe, GioStringFormatPipe],
  imports: [
    CommonModule
  ],
  exports: [GioDatePipe, GioNoSanitizePipe, GioEntityNamePipe, GioNameFormatterPipe, GioStringFormatPipe]
})
export class GioPipesModule { }
